/**
 * Optimize Cloudinary image URLs by adding auto-format, auto-quality, and responsive sizing.
 * Reduces image sizes by 90%+ (e.g., 3.9MB PNG → 270KB WebP).
 * Only transforms Cloudinary URLs — other URLs are passed through unchanged.
 */
export function optimizeCloudinaryUrl(url, { width, quality } = {}) {
  if (!url || typeof url !== 'string') return url;
  if (!url.includes('res.cloudinary.com')) return url;

  // Already has transformations
  if (url.includes('/f_auto') || url.includes('/q_auto')) return url;

  const transforms = ['f_auto', quality ? `q_${quality}` : 'q_auto'];
  if (width) transforms.push(`w_${width}`);

  // Insert transformations after /upload/
  return url.replace('/upload/', `/upload/${transforms.join(',')}/`);
}

/**
 * Get optimized image URL for specific use cases.
 */
export function heroImage(url) {
  return optimizeCloudinaryUrl(url, { width: 1920 });
}

export function cardImage(url) {
  return optimizeCloudinaryUrl(url, { width: 800 });
}

export function thumbnailImage(url) {
  return optimizeCloudinaryUrl(url, { width: 400 });
}

export function logoImage(url) {
  return optimizeCloudinaryUrl(url, { width: 200 });
}
